<div class="rds-c-stepper-container" (cdkObserveContent)="handleContentChange()">
  <ng-content></ng-content>
  <div class="rds-c-stepper-action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <button
      *ngIf="(matStepper?.selectedIndex || 0) > 0"
      mat-mini-fab
      aria-label="Go back"
      class="rds-c-stepper-back-button"
      (click)="previous()"
    >
      <mat-icon>arrow_back</mat-icon>
    </button>
    <mtna-extended-fab
      class="rds-c-stepper-continue-button"
      [color]="(matStepper?.selectedIndex | rdsOnLastStep: matStepper) ? 'accent' : 'primary'"
      [disabled]="nextButtonDisabled"
      icon="arrow_forward"
      (click)="!nextButtonDisabled ? next() : null"
      >{{ (matStepper?.selectedIndex | rdsOnLastStep: matStepper) ? nextButtonCompleteText : nextButtonText }}</mtna-extended-fab
    >
  </div>
</div>
